<template>
  <div>
    <div class='row pl-5'><router-link to="/adminhome"><< Back</router-link></div>
    <div class="row">
      
      <div class="col-md-8 offset-md-2 alert alert-info">
        Download this
        <a href="data/roles-sample.xlsx" target="_blank" download>sample file</a>, 
        fill it up and upload it to perform bulk create/update.
      </div>
      <div class="col-md-8 offset-md-2">
        <input type="file" id="uploadFile" class="form-control" />
      </div>
      <!-- <div class="col-md-4 offset-md-4 my-3">
        <input type="checkbox" id="clean" v-model="clean" />
        <label for="clean">Delete All Existing Records</label>
      </div> -->
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-primary" v-on:click="upload" :disabled='loading'>Upload</button>
      </div>
    </div>

    <div class="row ml-2">
      <button class="btn btn-success" v-on:click="getMinistryRoles">Fetch Current Roles</button>
    </div>
    <div class="row ml-2">
      <table class="table table-strip table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Role</th>
            <th>Desc</th>
            <th>Dept</th>
            <th>Req</th>
            <th>Criteria</th>
            <th>Commitment</th>
            <th>Centres</th>
            <th>Image</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="roles.length === 0">
            <td colspan="8">
              <i>Empty</i>
            </td>
          </tr>
          <tr v-for="r in roles">
            <td>{{r.id}}</td>
            <td>{{r.name}}</td>
            <td>{{r.description}}</td>
            <td>{{r.department}}</td>
            <td>{{r.requirement}}</td>
            <td>
              <ul>
                <li v-for="c in json(r.criteria)">{{c}}</li>
              </ul>
            </td>
            <td>
              <ul>
                <li v-for="c in json(r.commitment)">{{c}}</li>
              </ul>
            </td>
            <td>
              <div v-show="r.axisCentre">Axis</div>
              <div v-show="r.northEastCentre">NEC</div>
              <div v-show="r.westCentre">WEC</div>
              <div v-show="!r.axisCentre && !r.northEastCentre && !r.westCentre">
                <i>Not specified</i>
              </div>
            </td>
            <td>
                <img :src="'images/'+r.avatar" width="100px" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      roles: [],
      clean: false,
      loading: false
    };
  },
  methods: {
    upload: async function() {
      this.loading = true;
      let uploadFile = document.getElementById("uploadFile").files[0];
      let formData = new FormData();
      formData.append("file", uploadFile);
      if (this.clean) {
        formData.append("clean", true);
      }
      try {
        var response = await http.post("/ministryrole/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        this.roles = response.data;
      } catch (err) {
        console.error("file upload failed", err);
      }
      this.loading = false;
    },

    getMinistryRoles: async function() {
      try {
        let response = await http.get("/ministryrole?limit=999");
        this.roles = response.data;
        if(this.roles.length === 0){
            alert("No data found");
        }
      } catch (err) {
        console.error("fetch roles err", err);
      }
    },

    json: function(val) {
      
      try{
        return JSON.parse(val);
      }catch(err){
        console.error('JSON parse err', err);
        return val;
      }
    }
  },
  beforeMount: function() {}
};
</script>

<style>
</style>
